import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = {
  key: 0,
  class: "container mar_b"
}
const _hoisted_4 = { class: "t6_title_h1" }
const _hoisted_5 = { class: "t6_search btn" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "t6_search btn",
  style: {"right":"150px"}
}
const _hoisted_8 = {
  key: 1,
  class: "t6_search btn",
  style: {"right":"300px"}
}
const _hoisted_9 = {
  key: 2,
  class: "t6_search btn",
  style: {"right":"450px"}
}
const _hoisted_10 = {
  class: "t6_table_b",
  style: {"margin-bottom":"48px"}
}
const _hoisted_11 = { class: "t6_tab_tit2" }
const _hoisted_12 = { class: "tab_content" }
const _hoisted_13 = { class: "tab_cont" }
const _hoisted_14 = { class: "t6_table_c2" }
const _hoisted_15 = {
  key: 0,
  class: "textLeft"
}
const _hoisted_16 = {
  key: 1,
  class: "textLeft"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "tab_cont" }
const _hoisted_21 = { class: "tab_cont" }

import {useRoute, useRouter} from 'vue-router';
import {getServiceGuid} from '@/config/request';
import {onBeforeMount, reactive, ref} from 'vue';
import { IMG_PREVIEW } from '@/config/const';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
let serviceCode = route.query.serviceCode
let serviceName = route.query.serviceName
let tagName = route.query.tagName
let loading = ref(false)
let data = reactive({
    workGuideData: {} as any
})
const router = useRouter()
const externalLink = ref();
let tab = ref(1)
const changeTab = (index: number) => {
    tab.value = index
}
const loadFile=(value:string) => {
  if (value!==""){
    let fileId= value.split("fileId=")[1]
    return IMG_PREVIEW+fileId
  }
}
const downLoadGzcn = function (fileUrl: string) {
    window.open(fileUrl)
}

//attr：根据该属性排序；rev：升序1或降序-1，不填则默认为1
const sortBy = function (attr: string, rev: number) {
    if (rev == undefined) {
        rev = 1
    } else {
        (rev) ? 1 : -1
    }
    return (a: any, b: any) => {
        a = a[attr]
        b = b[attr]
        if (a < b) {
            return rev * -1
        }
        if (a > b) {
            return rev * 1
        }
        return 0
    }
}
const openFile = (name:string) => {
    if(name) window.open(`/staticFile/${name}`)
}

const init = async () => {
    let param = {
        serviceCode: serviceCode,
        tagName: route.query.tagName
    }
    const res = await getServiceGuid(param) as any
    data.workGuideData = res.result
    loading.value = true
}
// const toDeclaration = (serviceCode:any,serviceName: any) => {
//     let query = {
//         serviceCode: serviceCode,
//         serviceName: serviceName,
//         tagName: 'wzqy',
//     } as any
//     router.push({
//             path: '/do-things-online/notic',
//             query: query,
//     })
// }

onBeforeMount(()=>{
    init();
    if(serviceCode == 'Z231018XK1061M001'){
        externalLink.value = 'https://www.hnzwfw.gov.cn/portal/guide/666CA53FC832A5D3606E7701802E21AE?region=410200000000';
    }else if(serviceCode == 'Z231018XK4943J001'){
        externalLink.value = 'https://etax.henan.chinatax.gov.cn/web/dzswj/ythclient/mh.html';
    }else if(serviceCode == 'Z231018XK7694B001'){
        externalLink.value = 'http://qcdzh.scjg.henan.gov.cn/index.action';
    }else{
/*      toDeclaration(serviceCode,serviceName);
      init();*/
    }
})
const toDeclaration = () => {
  let query = {
    serviceCode: serviceCode,
    serviceName: serviceName,
    tagName: tagName,
  } as any
  router.push({
    path: '/do-things-online/notic',
    query: query,
  })
}
const isExternalLink = () => {
  console.log(externalLink.value)
  if (externalLink.value ===null|| externalLink.value ===undefined){
    return false
  }else {
    return true
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "no_banner" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "t6_breadCream" }, [
                _createElementVNode("span", null, "首页"),
                _createTextVNode(),
                _createElementVNode("i", null, ">"),
                _createTextVNode(),
                _createElementVNode("span", null, "网上办事"),
                _createTextVNode(),
                _createElementVNode("i", null, ">"),
                _createElementVNode("span", null, "办事指南")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_unref(data).workGuideData.preService.serviceName) + " ", 1),
                _createElementVNode("div", _hoisted_5, [
                  (isExternalLink())
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: externalLink.value
                      }, "事项办理", 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: toDeclaration
                      }, "事项办理"))
                ]),
                (_unref(serviceCode) == 'Z231018XK7694B001')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openFile('negativeList.docx')))
                      }, "附件2：负面清单")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(serviceCode) == 'Z231018XK7694B001')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openFile('sampleTable.docx')))
                      }, "附件1：样表")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(serviceCode) == 'Z231018XK7694B001')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("a", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openFile('handlingGuideline.docx')))
                      }, "办事指南")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "t6_title_h2" }, "基本信息", -1)),
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("th", { width: "180" }, "项目名称", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.serviceName), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("th", { width: "180" }, "所属局委", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.deptName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("th", null, "项目编号", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.serviceCode), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("th", null, "权利事项类型", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.serviceType_dictText), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("th", null, "法定期限", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.legalDays) + " 工作日", 1),
                    _cache[17] || (_cache[17] = _createElementVNode("th", null, "承诺期限", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(data).workGuideData.preService.promiseDays) + " 工作日", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 1}]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(1)))
                }, "申办材料", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 2}]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(2)))
                }, "申办依据", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 3}]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab(3)))
                }, "交通指引", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 4}]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeTab(4)))
                }, "收费标准", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 5}]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (changeTab(5)))
                }, "线下办理流程", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 6}]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (changeTab(6)))
                }, "办公时间", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 7}]),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (changeTab(7)))
                }, "咨询方式", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {'active':_unref(tab) === 8}]),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (changeTab(8)))
                }, "监督投诉", 2)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _createElementVNode("table", _hoisted_14, [
                    _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "序号"),
                        _createElementVNode("th", null, "材料名称"),
                        _createElementVNode("th", null, "复印件数"),
                        _createElementVNode("th", null, "原件份数"),
                        _createElementVNode("th", null, "样表下载"),
                        _createElementVNode("th", null, "材料必要性"),
                        _createElementVNode("th", null, "来源渠道")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).workGuideData.preServiceMaterialList, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                          (item.srcWay != '承诺告知')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(item.name), 1))
                            : _createCommentVNode("", true),
                          (item.srcWay == '承诺告知')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("a", {
                                  style: {"color":"red"},
                                  onClick: ($event: any) => (downLoadGzcn(item.fileUrl))
                                }, "【下载】", 8, _hoisted_17)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(item.srcNum) + " 份", 1),
                          _createElementVNode("td", null, _toDisplayString(item.copyNum) + " 份", 1),
                          _createElementVNode("td", null, [
                            (item.fileUrl)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: loadFile(item.fileUrl),
                                  onClick: _cache[11] || (_cache[11] = () => {})
                                }, "空表", 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            (item.examplefileUrl)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  style: {"margin-left":"4px","text-decoration":"none"},
                                  href: loadFile(item.examplefileUrl)
                                }, "样表", 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.importLevel == 1 ? '非必要' : (item.importLevel == 2 ? '必要' : (item.importLevel == 3 ? '容缺后补' : '无'))), 1),
                          _createElementVNode("td", null, _toDisplayString(item.submitRequire), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 512), [
                  [_vShow, _unref(tab) === 1]
                ]),
                _withDirectives(_createElementVNode("div", { class: "tab_cont" }, _toDisplayString(_unref(data).workGuideData.preService.legalStandard), 513), [
                  [_vShow, _unref(tab) === 2]
                ]),
                _withDirectives(_createElementVNode("div", { class: "tab_cont" }, _toDisplayString(_unref(data).workGuideData.preService.trafficGuide), 513), [
                  [_vShow, _unref(tab) === 3]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_20, " 暂无 ", 512), [
                  [_vShow, _unref(tab) === 4]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_steps, {
                    active: _unref(data).workGuideData.preServiceNodes.length,
                    "finish-status": "success",
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).workGuideData.preServiceNodes.sort(sortBy('sortid',1)), (item, i) => {
                        return (_openBlock(), _createBlock(_component_el_step, {
                          title: item.nodeName
                        }, null, 8, ["title"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["active"])
                ], 512), [
                  [_vShow, _unref(tab) === 5]
                ]),
                _withDirectives(_createElementVNode("div", { class: "tab_cont" }, _toDisplayString(_unref(data).workGuideData.preService.officeTime), 513), [
                  [_vShow, _unref(tab) === 6]
                ]),
                _withDirectives(_createElementVNode("div", { class: "tab_cont" }, _toDisplayString(_unref(data).workGuideData.preService.contactPhone), 513), [
                  [_vShow, _unref(tab) === 7]
                ]),
                _withDirectives(_createElementVNode("div", { class: "tab_cont" }, _toDisplayString(_unref(data).workGuideData.preService.monitorComplain), 513), [
                  [_vShow, _unref(tab) === 8]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, !_unref(loading)]
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})